<template>
  <v-dialog v-model="dialog" width="900">
    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        <v-icon color="green" class="mr-2">mdi-map-marker-radius-outline</v-icon>
        Zone Trattate
        <span v-if="evento" class="grey--text text--darken-1 ml-1 text-body-2"
          >— {{ data_evento }}</span
        >
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-progress-linear v-if="loading" indeterminate class="mb-2" />
        <template v-else-if="evento">
          <v-alert
            v-if="evento.id_serre.length && evento.id_zone.length"
            type="info"
            outlined
            dense
            class="mb-3"
          >
            Questo evento include anche riferimenti alla vecchia Zona
            (non mostrati sulla mappa):
            <v-chip
              v-for="id_zona in evento.id_zone"
              :key="id_zona"
              x-small
              outlined
              color="green darken-1"
              class="ml-1"
              >{{ nomeZona(id_zona) }}</v-chip
            >
          </v-alert>
          <template v-if="evento.id_serre.length && appezzamento_selezionato">
            <AppezzamentoCanvas
              :appezzamento="appezzamento_selezionato"
              :posizioni="posizioni"
              :serre="serre"
              :readonly="true"
              :hide_toolbar="true"
              :flat_mode="true"
              :evidenziate="evento.id_serre"
              :max_height="500"
              :list_cols="4"
              :list_max_height="500"
            />
          </template>
          <v-alert
            v-else-if="evento.id_zone.length"
            type="info"
            outlined
            dense
            class="mt-2"
          >
            Questo evento fa riferimento solo alla vecchia Zona di
            coltivazione, non mappabile sulla mappa aziendale:
            <v-chip
              v-for="id_zona in evento.id_zone"
              :key="id_zona"
              x-small
              outlined
              color="green darken-1"
              class="ml-1"
              >{{ nomeZona(id_zona) }}</v-chip
            >
          </v-alert>
          <v-alert v-else type="warning" outlined dense class="mt-2">
            Nessuna posizione registrata per questo evento.
          </v-alert>
        </template>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text color="grey" @click="dialog = false">Chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import AppezzamentoCanvas from "@/components/PianoColtivazione/Desktop/AppezzamentoCanvas.vue";

export default {
  name: "EventoMappaDialog",
  components: { AppezzamentoCanvas },
  data() {
    return {
      dialog: false,
      loading: false,
      evento: null,
      appezzamento_selezionato: null,
    };
  },
  computed: {
    appezzamenti() {
      return this.$store.getters.getAppezzamenti || [];
    },
    serre() {
      return this.$store.getters.getSerre || [];
    },
    posizioni() {
      if (!this.appezzamento_selezionato) return [];
      return this.$store.getters.getPosizioniAppezzamento(
        this.appezzamento_selezionato.id
      );
    },
    data_evento() {
      return this.evento ? moment.unix(this.evento.ts).format("DD MMMM YYYY") : "";
    },
  },
  methods: {
    open(evento) {
      this.evento = evento;
      this.dialog = true;
      this.appezzamento_selezionato = null;
      if (!evento.id_serre || !evento.id_serre.length) {
        this.loading = false;
        return;
      }
      const lista = this.appezzamenti;
      if (!lista.length) {
        this.loading = false;
        return;
      }
      this.loading = true;
      if (lista.length === 1) {
        this.$store
          .dispatch("fetchPosizioniAppezzamento", lista[0].id)
          .finally(() => {
            this.appezzamento_selezionato = lista[0];
            this.loading = false;
          });
        return;
      }
      // Più di un appezzamento: individua quello che contiene davvero le
      // serre evidenziate da questo evento, così l'evidenziazione non
      // finisce silenziosamente su una mappa sbagliata/vuota.
      Promise.all(
        lista.map((app) =>
          this.$store.dispatch("fetchPosizioniAppezzamento", app.id)
        )
      )
        .then(() => {
          const match = lista.find((app) =>
            this.$store.getters
              .getPosizioniAppezzamento(app.id)
              .some((pos) => evento.id_serre.includes(pos.id_serra))
          );
          this.appezzamento_selezionato = match || lista[0];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    nomeZona(id) {
      let zona = this.$store.getters.get_zona_by_id(id);
      return zona ? zona.nome : id;
    },
  },
};
</script>
